// Segundo factor del panel (backend/totp.py): opcional por usuario y obligable por instalación.

// La instalación lo exige y este usuario aún no lo ha activado: solo puede ir a «Usuarios» a activarlo.
export function necesitaSegundoFactor(user) {
  return Boolean(user?.totp_setup_required);
}

// 6 cifras de la app de autenticación (con espacios o sin ellos) o un código de recuperación «XXXX-XXXX».
export function codigoValido(texto) {
  const t = String(texto || "").replace(/\s/g, "").toUpperCase();
  return /^\d{6}$/.test(t) || /^[A-Z2-9]{4}-?[A-Z2-9]{4}$/.test(t);
}

// El token del primer paso ha caducado o ya se usó (backend: 401 con detail.code «mfa_caducado»): hay que volver a
// escribir la contraseña. Un código incorrecto (401 con texto) o un 429 se quedan en el segundo paso.
export function inicioCaducado(err) {
  return err?.response?.status === 401 && err?.response?.data?.detail?.code === "mfa_caducado";
}
